exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgColor{background-color:#000;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden!important}.loginPos{margin:0;position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f165b96c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 524
// module chunks = 0